import { c as _c } from "react/compiler-runtime";
import { groupBy } from 'lodash';
import { useMemo } from 'react';
import { getIsTotalColumn, IN_ESTATE_TOTAL_COLUMN_ID, OUT_OF_ESTATE_TOTAL_COLUMN_ID } from '../../BalanceSheetTable/BalanceSheetTable.columns';
import { BalanceSheetTable_BalanceSheetFragment } from '../../BalanceSheetTable/graphql/BalanceSheetTable.fragments.generated';
import { BalanceSheetConfigColumn } from '../BalanceSheetConfigPanel.types';
interface GroupedColumns {
  /** Draggable in-estate columns (excludes totals) */
  inEstateColumns: BalanceSheetConfigColumn[];
  /** The in-estate total column, if present */
  inEstateTotalColumn: BalanceSheetConfigColumn | null;
  /** Draggable out-of-estate columns (excludes totals) */
  outOfEstateColumns: BalanceSheetConfigColumn[];
  /** The out-of-estate total column, if present */
  outOfEstateTotalColumn: BalanceSheetConfigColumn | null;
}

/**
 * Derives grouped BalanceSheetConfigColumn lists from the balance sheet query response.
 * Columns are separated into in-estate vs out-of-estate, with total columns
 * extracted so they can be rendered as non-draggable pinned rows.
 */
export function useBalanceSheetConfigColumns(balanceSheet) {
  const $ = _c(13);
  let t0;
  bb0: {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [];
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        inEstateColumns: t1,
        inEstateTotalColumn: null,
        outOfEstateColumns: [],
        outOfEstateTotalColumn: null
      };
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const empty = t2;
    if (!balanceSheet) {
      t0 = empty;
      break bb0;
    }
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[2] !== balanceSheet.columnGroups || $[3] !== balanceSheet.columns) {
      const columnGroupMap = new Map(balanceSheet.columnGroups.map(_temp));
      const allColumns = balanceSheet.columns.map(column => ({
        id: column.ID,
        display: column.display,
        group: column.group,
        groupDisplay: columnGroupMap.get(column.group) ?? column.group,
        isTotalColumn: getIsTotalColumn(column),
        isHidden: column.isHidden
      }));
      const grouped = groupBy(allColumns, "group");
      let inGroup = "";
      let outGroup = "";
      for (const group_0 of Object.keys(grouped)) {
        if (grouped[group_0]?.some(_temp2)) {
          inGroup = group_0;
        } else {
          if (grouped[group_0]?.some(_temp3)) {
            outGroup = group_0;
          }
        }
      }
      t3 = (grouped[inGroup] ?? []).filter(_temp4);
      t4 = (grouped[inGroup] ?? []).find(_temp5) ?? null;
      t5 = (grouped[outGroup] ?? []).filter(_temp6);
      t6 = (grouped[outGroup] ?? []).find(_temp7) ?? null;
      $[2] = balanceSheet.columnGroups;
      $[3] = balanceSheet.columns;
      $[4] = t3;
      $[5] = t4;
      $[6] = t5;
      $[7] = t6;
    } else {
      t3 = $[4];
      t4 = $[5];
      t5 = $[6];
      t6 = $[7];
    }
    let t7;
    if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
      t7 = {
        inEstateColumns: t3,
        inEstateTotalColumn: t4,
        outOfEstateColumns: t5,
        outOfEstateTotalColumn: t6
      };
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t0 = t7;
  }
  return t0;
}
function _temp7(col_4) {
  return col_4.isTotalColumn;
}
function _temp6(col_3) {
  return !col_3.isTotalColumn;
}
function _temp5(col_2) {
  return col_2.isTotalColumn;
}
function _temp4(col_1) {
  return !col_1.isTotalColumn;
}
function _temp3(col) {
  return col.id === OUT_OF_ESTATE_TOTAL_COLUMN_ID;
}
function _temp2(col_0) {
  return col_0.id === IN_ESTATE_TOTAL_COLUMN_ID;
}
function _temp(group) {
  return [group.ID, group.display];
}